var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[
    'material-icons lbz-icon',
    _vm.size && ("lbz-icon--" + _vm.size),
    _vm.color && ("lbz-icon--" + _vm.color),
    _vm.disabled && 'lbz-is-disabled'
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }